module.exports = __webpack_public_path__ + "img/service_arror_bottom.415cc4b9.svg";